import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/app/services/auth.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent {
  readonly navList: INavListItem[] = [
    {
      routerLink: "/",
      iconName: "dashboard",
      label: "Dashboard",
    },
    {
      routerLink: "/faxes/send",
      iconName: "send-fax",
      label: "Send fax",
    },
    {
      routerLink: "/faxes",
      iconName: "search",
      label: "Search",
    },
    {
      routerLink: "/settings",
      iconName: "settings",
      label: "Settings",
    },
    {
      routerLink: "/subscription",
      iconName: "subscription",
      label: "Subscription",
    },
    {
      routerLink: "/phone-book",
      iconName: "phone-book",
      label: "Phone book",
    },
  ];

  readonly appVersion = "1.0.0";

  isCollapsed = false;

  constructor(private readonly _authService: AuthService, private readonly _router: Router) {}

  getIconSrc(navListItem: INavListItem) {
    return this.isCurrentUrlEquals(navListItem.routerLink)
      ? this.withBaseIconSrc(`${navListItem.iconName}-active.svg`)
      : this.withBaseIconSrc(`${navListItem.iconName}.svg`);
  }

  private withBaseIconSrc(iconSrc: string) {
    return `assets/icons/nav/${iconSrc}`;
  }

  isCurrentUrlEquals(url: string) {
    return this.activeNavListItem?.routerLink === url;
  }

  private get activeNavListItem(): INavListItem | null {
    const matchingItems = this.navList.filter(item => this.isUrlWithinRoute(item.routerLink));

    if (matchingItems.length === 0) {
      return null;
    }

    return matchingItems.reduce((longestMatch, item) =>
      item.routerLink.length > longestMatch.routerLink.length ? item : longestMatch
    );
  }

  private isUrlWithinRoute(routerLink: string) {
    if (routerLink === "/") {
      return this._router.url === "/";
    }

    return this._router.url === routerLink || this._router.url.startsWith(`${routerLink}/`);
  }

  signOut() {
    this._authService
      .signOut()
      .then(() => this.navigateToAuth())
      .catch(console.error);
  }

  private navigateToAuth() {
    this._router.navigate(["/auth"]);
  }

  toggleCollapsed() {
    this.isCollapsed = !this.isCollapsed;
  }
}

interface INavListItem {
  routerLink: string;
  iconName: string;
  label: string;
}
